/* eslint-disable */
import React from 'react';
import { Button, Col, Divider, Modal, Row, Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import colors from '~/constants/colors';
import { CloseXIcon, CheckBlackIcon } from '~/img';
import { DocumentInput } from '~/components';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { useDirection } from '~/hooks/i18nHooks';

function BusinessOwners(props: any) {
  const { data = {} } = props;
  const [openModal, setOpenModal] = React.useState<any>({ visible: false, data: {} });
  const { t } = useTranslation('ksaApplication');
  const isMobile = useIsMobile();
  const dir = useDirection();
  return (
    <div style={{ marginTop: 24 }}>
      <Typography.Title style={{ marginBottom: 15 }} level={4}>
        {t('Business Owners')}
      </Typography.Title>
      <Box dir={dir} isMobile={isMobile}>
        {data?.shareholders?.individuals
          ?.concat(data?.managers?.managers)
          ?.map((item: any, index: number, arr: any[]) => {
            return !isMobile ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 24,
                  // padding: 20,
                  // paddingTop: 30,
                  background: isMobile ? 'white' : 'transparent',
                  borderRadius: 8,
                  boxShadow: isMobile
                    ? '0px 2px 6px 0px rgba(0, 89, 150, 0.03), 0px -1px 8px -10px rgba(0, 89, 150, 0.03)'
                    : undefined,
                  // marginBottom: 30,
                }}
                key={item}
              >
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Typography.Paragraph className="labelKey">{t('Name')}</Typography.Paragraph>
                    <Typography.Paragraph className="value">
                      {item?.personalData?.fullName}
                    </Typography.Paragraph>
                  </Col>
                  <Col span={12}>
                    <Typography.Paragraph className="labelKey">
                      {t('Nationality')}
                    </Typography.Paragraph>
                    <Typography.Paragraph className="value">
                      {item?.personalData?.nationality}
                    </Typography.Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Typography.Paragraph className="labelKey">
                      {t('Government Issued ID')}
                    </Typography.Paragraph>
                    <Typography.Paragraph className="value">
                      {item?.personalDocument?.idNumber || item?.passport?.documentNumber}
                    </Typography.Paragraph>
                  </Col>
                </Row>
                {item?.personalData?.isAuthorizedSignatory &&
                  (!isMobile ? (
                    <SignatoryRow dir={dir}>
                      <SignatoryLeft>
                        <div className="checkIconWrapper">
                          <CheckBlackIcon className="checkIcon" />
                        </div>
                        <span className="signatoryText">
                          {t('This person is identified as authorized signatory.')}
                        </span>
                      </SignatoryLeft>
                      <LearnMoreButton
                        onClick={() =>
                          setOpenModal({
                            data: item,
                            visible: true,
                          })
                        }
                        className="learnMoreBtn"
                      >
                        {t('Learn More')}
                      </LearnMoreButton>
                    </SignatoryRow>
                  ) : (
                    <></>
                  ))}

                {!isMobile && index < arr.length - 1 && (
                  <Divider
                    className="businessOwnerDivider"
                  />
                )}
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 24,
                  // padding: 20,
                  // paddingTop: 30,
                  background: isMobile ? 'white' : 'transparent',
                  borderRadius: 8,
                  boxShadow: isMobile
                    ? '0px 2px 6px 0px rgba(0, 89, 150, 0.03), 0px -1px 8px -10px rgba(0, 89, 150, 0.03)'
                    : undefined,
                  marginBottom: 30,
                }}
                key={item}
              >
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Typography.Paragraph className="labelKey">{t('Name')}</Typography.Paragraph>
                  </Col>
                  <Col span={12}>
                    <Typography.Paragraph className="value">
                      {item?.personalData?.fullName}
                    </Typography.Paragraph>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Typography.Paragraph className="labelKey">
                      {t('Nationality')}
                    </Typography.Paragraph>
                  </Col>
                  <Col span={12}>
                    <Typography.Paragraph className="value">
                      {item?.personalData?.nationality}
                    </Typography.Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Typography.Paragraph className="labelKey">
                      {t('Government Issued ID')}
                    </Typography.Paragraph>
                  </Col>
                  <Col span={12}>
                    <Typography.Paragraph className="value">
                      {item?.personalDocument?.idNumber || item?.passport?.documentNumber}
                    </Typography.Paragraph>
                  </Col>
                </Row>
                {item?.personalData?.isAuthorizedSignatory &&
                  (!isMobile ? (
                    <SignatoryRow dir={dir}>
                      <SignatoryLeft>
                        <div className="checkIconWrapper">
                          <CheckBlackIcon className="checkIcon" />
                        </div>
                        <span className="signatoryText">
                          {t('This person is identified as authorized signatory.')}
                        </span>
                      </SignatoryLeft>
                      <LearnMoreButton
                        onClick={() =>
                          setOpenModal({
                            data: item,
                            visible: true,
                          })
                        }
                        className="learnMoreBtn"
                      >
                        {t('Learn More')}
                      </LearnMoreButton>
                    </SignatoryRow>
                  ) : (
                    <div>
                      <Typography.Paragraph
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          verticalAlign: 'middle',
                          paddingTop: 4,
                          fontSize: 14,
                        }}
                        className="labelKey"
                      >
                        {t('This person is identified as authorized signatory.')}
                      </Typography.Paragraph>
                      <div
                        style={{
                          gap: 8,

                          width: '100%',
                          padding: '12px 16px',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          alignSelf: 'stretch',
                          display: 'flex',
                          borderRadius: '8px',
                          backgroundColor: '#E6F0F7',
                        }}
                      >
                        <div className="checkIconWrapper">
                          <CheckBlackIcon className="checkIcon" />
                        </div>
                        <Button
                          onClick={() =>
                            setOpenModal({
                              data: item,
                              visible: true,
                            })
                          }
                          type="default"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '20px', // adjust horizontal padding as needed
                            height: '26px',
                            fontSize: 13,
                          }}
                        >
                          {t('Learn More')}
                        </Button>
                      </div>
                    </div>
                  ))}

                {!isMobile && (
                  <Divider
                    style={{ borderTop: `1px solid ${colors.grey[400]}`, fontWeight: 'bold' }}
                  />
                )}
              </div>
            );
          })}
      </Box>
      <ModalAnt
        dir={dir}
        isMobile={isMobile}
        centered={!isMobile}
        footer={null}
        closable={false}
        width={isMobile ? '100vw' : 800}
        visible={openModal.visible}
        onCancel={() => setOpenModal({ visible: false, data: {} })}
        style={
          isMobile
            ? {
              position: 'fixed',
              bottom: 0,
              top: 'auto',
              left: 0,
              right: 0,
              margin: 0,
              paddingBottom: 0,
              maxWidth: '100vw',
            }
            : undefined
        }
        title={
          <SignatoryTitleRow dir={dir}>
            <Typography.Text className="modalTitle">
              {t('Authorized Signatory details')}
            </Typography.Text>
            <SignatoryCloseBtn
              onClick={() => setOpenModal({ visible: false, data: {} })}
              id="signatoryModal_closeBtn"
            >
              <CloseXIcon />
            </SignatoryCloseBtn>
          </SignatoryTitleRow>
        }
      >
        <DetailRow dir={dir}>
          <Typography.Text className="labelKey">{t('Name')}</Typography.Text>
          <Typography.Text className="value">
            {openModal.data?.personalData?.fullName}
          </Typography.Text>
        </DetailRow>
        <DetailRow dir={dir}>
          <Typography.Text className="labelKey">{t('Mobile')}</Typography.Text>
          <Typography.Text className="value">
            <span dir="ltr" style={{ direction: 'ltr', display: 'inline-block' }}>
              {openModal.data?.personalData?.phoneNumber}
            </span>
          </Typography.Text>
        </DetailRow>
        <DetailRow dir={dir}>
          <Typography.Text className="labelKey">{t('Email')}</Typography.Text>
          <Typography.Text className="value">
            {openModal.data?.personalData?.email}
          </Typography.Text>
        </DetailRow>
        {!!Object?.keys(openModal?.data?.files || {})?.length && (
          <div style={{ marginTop: 16 }}>
            <Typography.Paragraph
              style={{ marginBottom: 8 }}
              className="proofLabelKey"
            >
              {t('Authorized Signatory Proof')}
            </Typography.Paragraph>
            <DocumentInput multiple={false} value={openModal?.data?.files} name="photo" />
          </div>
        )}
      </ModalAnt>
    </div>
  );
}

const SignatoryTitleRow = styled.div<{ dir?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .modalTitle {
    color: #070707;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
  }
`;

const SignatoryCloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }
`;

const DetailRow = styled.div<{ dir?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  gap: 16px;

  .labelKey {
    color: #4A4A4A;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
    flex-shrink: 0;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
  }

  .value {
    color: #070707;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin: 0;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'left' : 'right')};
    word-break: break-word;
  }
`;

const ModalAnt = styled(Modal) <any>`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  direction: ${({ dir }) => dir || 'ltr'};
  text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};

  width: ${({ isMobile }) => (isMobile ? '100vw !important' : '800px !important')};
  max-width: ${({ isMobile }) => (isMobile ? '100vw !important' : '800px !important')};

  .ant-modal-header {
    padding: ${({ isMobile }) => (isMobile ? '24px 24px 20px 24px' : '32px 32px 24px 32px')};
    border-bottom: none;
    border-radius: ${({ isMobile }) => (isMobile ? '20px 20px 0 0' : '16px')} !important;
  }

  .ant-modal-body {
    padding: ${({ isMobile }) => (isMobile ? '0 24px 32px 24px' : '0 32px 32px 32px')} !important;
    max-height: ${({ isMobile }) => (isMobile ? '80vh' : '600px')};
    overflow-y: auto;
  }

  .ant-modal-content {
    direction: ${({ dir }) => dir || 'ltr'};
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
    border-radius: ${({ isMobile }) => (isMobile ? '20px 20px 0 0' : '16px')};
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08);
  }

  .proofLabelKey {
    color: #4A4A4A;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 8px;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
  }

  /* Mobile: Bottom Sheet docked at bottom */
  @media (max-width: 768px) {
    position: fixed !important;
    bottom: 0 !important;
    top: auto !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    padding-bottom: 0 !important;

    .ant-modal-content {
      border-radius: 20px 20px 0 0 !important;
    }
  }
`;

const Box = styled.div<any>`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  background-color: ${({ isMobile }) => (isMobile ? '#ffffff' : '#F9F9F9')};
  padding: 20px 16px;
  border-radius: 8px;
  border: 1px solid #F5F5F5;
  box-shadow: 0 2px 6px 0 rgba(0, 89, 150, 0.03), 0 -1px 8px -10px rgba(0, 89, 150, 0.03);

  .labelKey {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 14px;
    letter-spacing: 0.14px;
    // margin-bottom: 8px;
  }

  .value {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
  }

  .businessOwnerDivider {
    border-top: 1px solid #ddd !important;
    font-weight: bold !important;
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }

  .checkIconWrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 50%;
    background-color: #aaddc2;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .checkIcon {
    width: 20px;
    height: 20px;
  }
`;

const SignatoryRow = styled.div<any>`
  display: flex;
  flex-direction: ${({ dir }) => (dir === 'rtl' ? '' : 'row')};
  align-items: center;
  // justify-content: space-between;
  width: 100%;
  margin-top: 8px;
  gap: 12px;
`;

const SignatoryLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  .checkIconWrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 50%;
    background-color: #aaddc2;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
  }

  .checkIcon {
    width: 20px;
    height: 20px;
  }

  .signatoryText {
    color: #1c2027;
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
`;

const LearnMoreButton = styled(Button as any)`
  &&&.learnMoreBtn,
  .MainContent &&&.learnMoreBtn {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #ffffff !important;
    border: 1px solid #e5e7eb !important;
    border-radius: 8px !important;
    color: #1c2027 !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    padding: 6px 40px !important;
    height: 40px !important;
    gap: 10px !important;
    min-width: unset !important;
    max-width: max-content !important;
    width: auto !important;        
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.04) !important;

    &:hover,
    &:focus {
      background: #f9fafb !important;
      border-color: #d1d5db !important;
      color: #1c2027 !important;
    }
  }
`;

export default BusinessOwners;
